export default __webpack_public_path__ + "static/media/mockup-step-3-2.c61fe81a.png";